
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from "react-redux"
import { useSearchParams } from "react-router-dom"
import { useAuthState } from '../../../../../Helper/Context';
import { DeleteElEProjectWiseWorkNamePostDataAPI, ProjectWiseWorkNameTableDataAPI } from '../../../../../Redux/SidebarMasterSlice/ProjectWiseWorkName';
import { Loading } from '../../../../../Helper/Loading';
import { Pegination } from '../../../../../Components/Pegination/Pegination';
import DeletePopup from '../../GardenPopup/DeletePopup';
import Header from '../../../../../Components/Header/Header';
import Sidebar from '../../../../../Components/Sidebar/Sidebar';
import { ElEProjectNameDDL } from '../../../../../Components/CommonDDL/ElEProjectNameDDL';
import { ElEProjectWiseWorkNameDDL } from '../../../../../Components/CommonDDL/ElEProjectWiseWorkNameDDL';
import AddElEProjectWiseWorkName from './Modal/AddElEProjectWiseWorkName';


export const EleProjectWiseWorkName = () => {

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")
    let DashProjectTypeId = searchParams.get("DashProjectTypeId")

    // ----------pagination-------------
    const [PerPageCount, setPerPageCount] = useState(10)
    const [From, setFrom] = useState(1)
    const [To, setTo] = useState(10)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)
    const [IsPost, setIsPost] = useState(false)
    const [ProjectWiseWorkNamePopupShow, setProjectWiseWorkNamePopupShow] = useState()
    const [DeletePopupShow, setDeletePopupShow] = useState()
    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')
    const [isSearch, setIsSearch] = useState(false)
    const [IsClear, setIsClear] = useState(false)

    const handleAddOnClick = () => {
        setapiFlag('Insert')
        setProjectWiseWorkNamePopupShow(true)
    }
    const handleEditOnClick = (item) => {
        setProjectWiseWorkNamePopupShow(true)
        setapiFlag('Update')
        setrowData(item)
    }

    const handleOnCloseClick = () => {
        setProjectWiseWorkNamePopupShow(false)
    }

    const [ProjectName, setProjectName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [ProjectType, setProjectType] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [WorkType, setWorkType] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [WorkSubType, setWorkSubType] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [WorkName, setWorkName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const handleIsPost = () => {
        setIsPost(!IsPost)
        // if (tableData && tableData.table && tableData.table.length > 0) {
        //     setCurrentPage(0)
        //     setFrom(1)
        //     setTo(10)
        // }
    }

    const handleClear = () => {
        setTo(10)
        setFrom(1)
        setCurrentPage(0)
        setIsClear(!IsClear)
        setProjectName({
            ...ProjectName,
            ID: 0,
            Label: 'Select...'
        })
        setWorkName({
            ...WorkName,
            ID: 0,
            Label: 'Select...'
        })
        setProjectType({
            ...ProjectType,
            ID: 0,
            Label: 'Select...'
        })
    }

    useEffect(() => {
        const data = {
            M_ELEC_ProjectWiseWorkID :'0',
            M_ELEC_WorkID :WorkName.ID,
            M_ProjectWiseWorkID: 0,
            M_ProjectID: ProjectName.ID,
            M_ProjectTypeID: ProjectTypeId == 1 ? DashProjectTypeId : ProjectTypeId,
            M_WorkID: WorkName.ID,
            WorkName: '',
            M_UserID: UserID,
            token: token,
            From: From,
            To: To,
        }
        dispatch(ProjectWiseWorkNameTableDataAPI({ data }))
    }, [IsPost, To, IsClear, isSearch])

    const { tableData, isLoading } = useSelector(state => state.ProjectWiseWorkNameTableData)

    const handleSearch = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsSearch(!isSearch)
    }

    const handleDeleteApi = (item) => {
        const data = {
            M_ELEC_ProjectWiseWorkID: item.m_eleC_ProjectWiseWorkID,
            M_UserID: UserID,
            token: token,
            handleIsPost: handleIsPost
        }
        dispatch(DeleteElEProjectWiseWorkNamePostDataAPI({ data }))
    }

    const { isDeleteLoading } = useSelector(state => state.DeleteElEProjectWiseWorkNamePostData)

    // useEffect(() => {
    //     setCurrentPage(0)
    //     setFrom(1)
    //     setTo(10)
    // }, [ProjectName.ID, ProjectType.ID, WorkName.ID])

    // const [SelectWard, setSelectWard] = useState({
    //     DDL: [],
    //     ID: 0,
    //     Label: "Select Ward",
    // })

    return (
        <>
            {isLoading && <Loading />}
            {isDeleteLoading && <Loading />}
            <div>

                <Header
                    // DashboardHeading="Garden Maintainance"
                    DashboardName={DashboardName}
                />

                <div className="wrapper p-3">

                    <Sidebar
                        ProjectTypeId={ProjectTypeId}
                        DashProjectTypeId={DashProjectTypeId}
                        active='projectwiseworkname'
                        listActive="elec0trical" />

                    <div className="content">
                        {/* <!-- [ breadcrumb ] start --> */}
                        <div className="page-header ">
                            <div className="page-block">
                                <div className="row align-items-center">
                                    <div className="col-md-12">
                                        {/* <div className="page-header-title">
                                            <h5 className="ps-2 data_mob">MASTER */}
                                        {/* <!-- <span className="float-end">namita</span> --> */}
                                        {/* <span className="float-end fs-6">
                                                <Select
                                                    // isClearable
                                                    // isRtl={isRtl}
                                                    isSearchable
                                                    maxMenuHeight={150}
                                                    value={{ value: SelectWard.ID, label: SelectWard.Label }}
                                                    onChange={(e) => {
                                                        e ?
                                                            setSelectWard({ ...SelectWard, ID: e.value, Label: e.label })
                                                            :
                                                            setSelectWard({ ...SelectWard, ID: 0, Label: "Select..." })

                                                    }}
                                                    options={SelectWard.DDL}
                                                />

                                            </span> */}
                                        {/* </h5>

                                        </div> */}

                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <!-- [ Main Content ] start --> */}
                        <div className="data_mob">
                            <div className="row col-12 m-1 py-1 pb-4 master_border">

                                <div className='col-12 row'>
                                    <div className="col-12 col-lg-5">
                                        <h5 className="ps-1 py-1">Project Wise Work Name Master</h5>
                                    </div>

                                    <div className="col-12 col-lg-3">
                                        <h5 className="ps-1 py-1">Total Count =
                                            <text style={{ color: '#048A8B', fontSize: '18px' }}>
                                                &nbsp;{tableData && tableData.table && tableData.table.length > 0 && tableData.table[0]?.totalCount ? tableData.table[0]?.totalCount : '0'}
                                            </text>
                                        </h5>
                                    </div>

                                    <div className="col-12 col-lg-4 float-end mt-4 pt-1">
                                        <i className="fa-solid fa-plus float-end btn btn-secondary mb-2"
                                            style={{ color: "white", marginTop: '-2em' }} onClick={handleAddOnClick}
                                        >
                                            <text className="ml-2 poppins">Add</text>
                                        </i>
                                    </div>
                                </div>



                                <div className="row m-0">
                                    <div className="col-12 py-1 rounded rounded-2 shadow"
                                        style={{ border: "1px solid #00000024", background: " #27466317" }}>
                                        <div className="col-12  ">

                                            <div className="row py-1 rounded2">
                                                {/* <div className="col-12 col-md-6 col-lg-3">
                                                    <ProjectTypeDataDDL
                                                        ProjectType={ProjectType}
                                                        setProjectType={setProjectType}

                                                    />

                                                </div> */}
                                                <div className="col-12 col-md-4 col-lg-3">

                                                    <ElEProjectNameDDL
                                                        ProjectName={ProjectName}
                                                        setProjectName={setProjectName}
                                                        M_ProjectTypeID={ProjectTypeId}
                                                    />

                                                </div>
                                                <div className="col-12 col-md-4 col-lg-3">
                                                    <ElEProjectWiseWorkNameDDL
                                                        WorkName={WorkName}
                                                        setWorkName={setWorkName}
                                                        APIFlag="ProjectWiseWork"
                                                        ProjectName={ProjectName}
                                                        IsPost={IsPost}
                                                    />
                                                </div>
                                                <div className="col-12 col-md-3 col-lg-3 mt-md-4 mt-lg-4 d-md-flex" >
                                                    <button type="button"
                                                        className="btn-clear btn btn-primary mx-2"
                                                        onClick={handleSearch}
                                                    >
                                                        Search</button>
                                                    <button type="button"
                                                        className="btn btn-outline-danger"
                                                        onClick={handleClear}
                                                    >
                                                        Clear</button>
                                                </div>
                                            </div>
                                            <div className="row mob_table table-responsive pt-1">

                                                <table id="totalordergenerated"
                                                    cellPadding="0"
                                                    cellSpacing="0"
                                                    border="0"
                                                    className="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th className="sr_no_col">Sr No.</th>
                                                            <th>Project Name</th>
                                                            <th>Work Type</th>
                                                            <th>Work Sub Type</th>
                                                            <th>Work Name</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item) => (
                                                                <tr style={{ width: '100%' }}>
                                                                    <td style={{ textAlign: "center" }}>{item.rowNum}</td>
                                                                    <td>{item.projectName ? item.projectName : '-'}</td>
                                                                    <td>{item.workTypeName ? item.workTypeName : '-'}</td>
                                                                    <td>{item.workSubTypeName ? item.workSubTypeName : '-'}</td>
                                                                    <td>{item.workName ? item.workName : '-'}</td>
                                                                    <td style={{ textAlign: "center", width: '7%' }}>
                                                                        <span>
                                                                            <i className="fa-solid fa-pen-to-square" title='Edit'
                                                                                style={{ cursor: 'pointer' }}
                                                                                onClick={() => handleEditOnClick(item)}
                                                                            >
                                                                            </i>
                                                                        </span>

                                                                        <DeletePopup
                                                                            open={DeletePopupShow}
                                                                            item={item}
                                                                            handleDeleteApi={handleDeleteApi}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            ))
                                                                :
                                                                <td colSpan={10}>No data found</td>
                                                        }

                                                    </tbody>
                                                </table>

                                            </div>
                                            {tableData && tableData.table && tableData.table.length > 0 &&
                                                <Pegination
                                                    PerPageCount={PerPageCount}
                                                    TotalCount={tableData.table[0].totalCount}
                                                    setFrom={setFrom}
                                                    setTo={setTo}
                                                    setrowNo={setrowNo}
                                                    CurrentPage={CurrentPage}
                                                    setCurrentPage={setCurrentPage}
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                {
                    ProjectWiseWorkNamePopupShow ?
                        <AddElEProjectWiseWorkName
                            open={ProjectWiseWorkNamePopupShow}
                            // popupHeading="Location Name"                         
                            handleIsPost={handleIsPost}
                            handleOnCloseClick={handleOnCloseClick}
                            Flag={apiFlag}
                            rowData={rowData}
                        />
                        : <></>
                }
            </div>
        </>
    )
}